import type { Bindings, ChildLoggerOptions, Logger } from "pino";
import type { PinoModuleString } from "./pinoModules.js";

/**
 * Shared default pino-compatible level mapping for frontend and backend.
 *
 * Keep the gaps between values (10, 20, 30, ...) to leave space for future
 * custom levels (e.g. 9, 11, 21) without remapping core levels.
 */
export const DefaultLogLevels = {
    silent: Infinity,
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10,
} as const;

/** The runtime environments the logging package can initialize for. */
export type LoggingEnvironment = "browser" | "node" | "test";

export type LogRecord = {
    level: number;
    module?: string;
    message?: string;
    args: unknown[];
    [key: string]: unknown;
};
export type LogInterceptor = (record: LogRecord) => void;

export type RootLoggerChildBindings<TModuleString extends string = PinoModuleString> = Bindings & {
    module: TModuleString;
};

export type RootLoggerType<TModuleString extends string = PinoModuleString> = Omit<Logger, "child"> & {
    child<ChildCustomLevels extends string = never>(
        bindings: RootLoggerChildBindings<TModuleString>,
        options?: ChildLoggerOptions<ChildCustomLevels>,
    ): Logger<ChildCustomLevels>;
};
